import { PolicyContactAddressField, PolicyContactAddressOperator } from "shared";

import { Select } from "../../../../../../common/Atoms/Select";
import { InputTextAddon } from "../../../../../../common/Atoms/InputTextAddon";
import { fieldIsValid } from "../../../../../lib/helper";

import { IFieldProps } from "./fieldProps";

export function ContactAddressFilter({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  function onFilterFieldChange({ value }: { value: string | number }) {
    handleChange({
      name: `contact_address_filter_field`,
      value,
    });
  }

  function onFilterOperatorChange({ value }: { value: string | number }) {
    handleChange({
      name: `contact_address_filter_operator`,
      value,
    });
  }

  function clearFilter() {
    handleChange({
      name: `contact_address_filter_field`,
      value: null,
    });

    handleChange({
      name: `contact_address_filter_operator`,
      value: null,
    });

    handleChange({
      name: `contact_address_filter_value`,
      value: null,
    });
  }

  function onFilterValueChange({ value }: { value: string | number }) {
    const nextValue = `${value ?? ``}`.trim();

    if (!nextValue) {
      clearFilter();

      return;
    }

    handleChange({
      name: `contact_address_filter_value`,
      value: nextValue,
    });
  }

  return (
    <div className={ `flex justify-between items-end space-x-4` }>
      <div className={ `w-full` }>
        <Select
          options={ [
            { value: PolicyContactAddressField.COUNTRY, label: `Country` },
            { value: PolicyContactAddressField.STATE, label: `State` },
            { value: PolicyContactAddressField.CITY, label: `City` },
          ] }
          selected={ policyFormData.contact_address_filter_field || PolicyContactAddressField.COUNTRY }
          onChange={ onFilterFieldChange }
          name={ `contact_address_filter_field` }
          invalid={ fieldIsValid(`contact_address_filter_field`, invalids) }
          valueClassname={ `text-gray-500` }
        />
      </div>

      <div className={ `w-full` }>
        <Select
          options={ [
            { value: PolicyContactAddressOperator.IS, label: `Is` },
            { value: PolicyContactAddressOperator.IS_NOT, label: `Is not` },
            { value: PolicyContactAddressOperator.CONTAINS, label: `Contains` },
          ] }
          selected={ policyFormData.contact_address_filter_operator || PolicyContactAddressOperator.IS }
          onChange={ onFilterOperatorChange }
          name={ `contact_address_filter_operator` }
          invalid={ fieldIsValid(`contact_address_filter_operator`, invalids) }
          valueClassname={ `text-gray-500` }
        />
      </div>

      <div className={ `w-full` }>
        <InputTextAddon
          value={ policyFormData.contact_address_filter_value || `` }
          onChange={ onFilterValueChange }
          name={ `contact_address_filter_value` }
          invalid={ fieldIsValid(`contact_address_filter_value`, invalids) }
          placeholder={ `Enter value` }
        />
      </div>
    </div>
  );
}
